import cn from 'clsx'
import { OffCanvasHeader } from './off-canvas-header'
import { OffCanvasBody } from './off-canvas-body'
import { OffCanvaseWrap, OffCanvasInner } from './style'

const OffCanvas = ({ children, onClick, className, ...props }) => {
  return (
    <OffCanvaseWrap
      {...props}
      onClick={onClick}
      className={cn(className, 'offcanvas')}
    >
      <OffCanvasInner {...props} onClick={(e) => e.stopPropagation()}>
        {children}
      </OffCanvasInner>
    </OffCanvaseWrap>
  )
}

export { OffCanvasHeader, OffCanvasBody }
export default OffCanvas
